import Component from '../../classes/Component';
import Swiper, {Navigation} from "swiper";
import variables from "../../variables";

const carouselRootId = 'js-gallery-carousel';
const preloaderClassName = 'js-page-gallery-preloader';
const btnPrevSelector = '.js-page-gallery-prev';
const btnNextSelector = '.js-page-gallery-next';
const {breakpoints} = variables;

export default function () {
    const $Page = this;

	return new Component({
		name: 'galleryCarousel',
		requiredTargets: '#'+carouselRootId,
		onInit() {

		    this.initCarousel = () => {
                this.carousel = new Swiper('#'+carouselRootId+' .swiper', {
                    modules: [Navigation],
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    loop: true,
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                    lazyPreloaderClass: preloaderClassName,
                    navigation: {
                        nextEl: '#'+carouselRootId + ' ' + btnNextSelector,
                        prevEl: '#'+carouselRootId + ' ' + btnPrevSelector,
                    },
                    breakpoints: {
                        0: {
                            spaceBetween: 12,
                        },
                        [variables.breakpoints.md]: {
                            spaceBetween: 24,
                        },
                    }
                })
            };

            this.destroyCarousel = () => {
                if (this.carousel instanceof Swiper) {
                    this.carousel.destroy();
                    this.carousel = null;
                }
            };

            this.checkScreen = () => {
                const ww = variables.windowWidth;

                if (ww >= breakpoints.md) {
                    this.destroyCarousel()
                } else {
                    this.initCarousel()
                }
            };

            this.checkScreen();
            $Page.addResizeDependentMethod(this.checkScreen);
        },
		onDestroy() {
            this.destroyCarousel()
        }
	})
}
